(function () {
  var panel = document.getElementById('collection-selector');
  if (!panel) return;

  var dialog = panel.querySelector('.collection-selector__panel');
  var lastFocused = null;
  var previousBodyOverflow = '';

  function focusableElements() {
    return Array.prototype.slice.call(
      dialog.querySelectorAll('a[href], button:not([disabled])')
    );
  }

  function open(trigger) {
    lastFocused = trigger || document.activeElement;
    previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    panel.hidden = false;
    document.addEventListener('keydown', onKeydown, true);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        panel.classList.add('collection-selector--visible');
      });
    });

    var focusables = focusableElements();
    if (focusables.length) focusables[0].focus();
  }

  function close() {
    panel.classList.remove('collection-selector--visible');
    document.body.style.overflow = previousBodyOverflow;
    document.removeEventListener('keydown', onKeydown, true);

    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
    lastFocused = null;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(
      function () {
        panel.hidden = true;
      },
      reduceMotion ? 0 : 300
    );
  }

  function onKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }

    if (event.key !== 'Tab') return;

    var focusables = focusableElements();
    if (!focusables.length) return;

    var first = focusables[0];
    var last = focusables[focusables.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  panel.querySelectorAll('[data-collection-selector-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  function isMobile() {
    return window.innerWidth < 750;
  }

  function bindTrigger(el) {
    el.addEventListener('click', function (event) {
      event.preventDefault();
      open(el);
    });
  }

  // Desktop hero CTA + desktop header "Colección" link — unchanged from
  // earlier rounds, always open the selector regardless of viewport.
  var heroCta = document.querySelector('.hero a[href="/collections"]');
  if (heroCta) bindTrigger(heroCta);

  document.querySelectorAll('a.menu-list__link').forEach(function (link) {
    if (link.textContent.trim() === 'Colección') bindTrigger(link);
  });

  // Mobile drawer "Colección": close the drawer first (via its own real
  // close button, so the theme's own scroll-lock/animation logic runs),
  // then open the selector once the drawer's close transition is done.
  document.querySelectorAll('[data-collection-selector-trigger="drawer"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      if (!isMobile()) return;
      event.preventDefault();
      var trigger = link;
      var drawerCloseButton = document.querySelector('.menu-drawer__close-button');
      if (drawerCloseButton) {
        drawerCloseButton.click();
        setTimeout(function () {
          open(trigger);
        }, 320);
      } else {
        open(trigger);
      }
    });
  });

  // Mobile cart empty-state "Descubrir la colección →": close the cart
  // drawer (if the cart is rendered as a drawer) before opening the
  // selector, so only one overlay is ever active at once.
  document.querySelectorAll('.cart-items__empty-button').forEach(function (link) {
    link.addEventListener('click', function (event) {
      if (!isMobile()) return;
      event.preventDefault();
      var trigger = link;
      var cartCloseButton = document.querySelector('.cart-drawer__close-button');
      if (cartCloseButton) {
        cartCloseButton.click();
        setTimeout(function () {
          open(trigger);
        }, 320);
      } else {
        open(trigger);
      }
    });
  });
})();
